module.exports = __webpack_public_path__ + "static/media/bulkActions-HintArrow.1750cc20.svg";